import React, { useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2'
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import { useParams } from "react-router-dom";
import ReactPlayer from 'react-player'
import "./DynamicSentence.css";
import './matchcss.css';
import { useRef } from "react"; // ekle
import useSubjectName from './useSubjectName';
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const Link = (props) => {
    const { t } = useTranslation()
    const [hasMediaContent, sethasMediaContent] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [parts, setParts] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [obj, setObj] = useState([]);
    const [answ, setAnsw] = useState([]);
    const [url, setUrl] = useState([]);
    const [soundurl, setSoundurl] = useState([]);
    const [link, setLink] = useState("");

    const [ans, setAns] = useState([]);
    const [sentenceText, setSentenceText] = useState("");
    const [zoomLevel, setZoomLevel] = useState(1);
    const [sentenceAnswers, setSentenceAnswers] = useState([]);
    const { user } = useAuth();
    const params = useParams();
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const subjectName = useSubjectName();
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;
    const containerRef = useRef(null);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const openFullscreen = () => {
        containerRef.current?.requestFullscreen();
    };
    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            containerRef.current?.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };
    const getDynamicPadding = () => {
        const ratio = imageDimensions.width / imageDimensions.height;
        if (ratio > 1) {
            // Yatay (16:9 gibi)
            return { paddingTop: "10px", paddingBottom: "10px" };
        } else if (ratio < 1) {
            // Dikey (9:16 gibi)
            return { paddingLeft: "10px", paddingRight: "10px" };
        }
        return {}; // Kare resimler için padding yok
    };

    // Medya türü kontrolü yaparak boş kutuyu engelle

    const Request = async (userAnswer) => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/user/Content/Answer`;
            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data['success']) {
                    props.playSuccessSound?.();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                    });
                }
                else {
                    if (res.data['alertType'] === "question") {
                        props.playErrorSound?.();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: "Doğru Cevap: " + res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                    else {
                        let errorMsg = res['data']['message'];
                        props.playErrorSound?.();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        }
        catch (err) {
            console.log(err.message);
        }
    }
    const handleZoomIn = () => {
        setZoomLevel(prev => Math.min(prev + 0.05, 2)); // Maksimum %200
    };

    const handleZoomOut = () => {
        setZoomLevel(prev => Math.max(prev - 0.05, 0.5)); // Minimum %50
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        Request(props.data.answer);
    };
    useEffect(() => {
        if (!isFullscreen) {
            setZoomLevel(1);
        }
    }, [isFullscreen]);
    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);

        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        };
    }, []);
    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }

        return () => {
            localStorage.removeItem(ATTEMPT_KEY);
        };
    }, [ATTEMPT_KEY]);
    useEffect(() => {
        setObj(JSON.parse(props.data.contentStr))
        var question = JSON.parse(props.data.contentStr)['text']
        var questionn = JSON.parse(props.data.contentStr);
        var questionTitlee = questionn['text'].split('__')[0];
        let questionTextt = questionn['text'].split('__')[1];
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
        if (obj['type'] === "sound" || obj['type'] === "video" || obj['type'] === "image" || obj['type'] === "image_sound") {
            sethasMediaContent(true)
        }
        else {
            sethasMediaContent(false)

        }
        // "detail" alanına ya düz bir URL ya da Wordwall'ın verdiği tam <iframe> gömme
        // kodu yapıştırılmış olabilir. Tam iframe kodu geldiyse içindeki src="..." değerini
        // çıkarıp kendi iframe sarmalayıcımızda (zoom/tam ekran özellikleriyle) kullanıyoruz.
        const rawDetail = props.data.detail || "";
        const iframeSrcMatch = rawDetail.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
        setLink(iframeSrcMatch ? iframeSrcMatch[1] : rawDetail.trim());

    }, []);
    return (
        <div>
            <span style={{ color: "black" }}> <b><i>{subjectName}</i></b></span>
            <br />
            <br />
            <div style={{ alignItems: "center", textAlign: "center" }}>
                {obj['type'] === "image_sound" ? (
                    <div>
                        <div style={{
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",  // sadece medya varsa flex, yoksa block
                            width: "100%",
                            maxWidth: "500px",
                            margin: "0 auto",
                            overflow: "hidden",
                            padding: "10px"
                        }}>
                            <div style={{
                                width: "100%",
                                height: "auto",
                                maxWidth: "500px"
                            }}>
                                <ReactAudioPlayer
                                    src={url}
                                    autoPlay={false}
                                    controls={true}
                                    controlsList="nodownload "

                                />
                            </div>

                        </div>
                        <br />
                        <div style={{
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",  // sadece medya varsa flex, yoksa block
                            width: "auto",
                            maxWidth: "auto",
                            margin: "0 auto",
                            overflow: "hidden",
                            padding: "10px"
                        }}>
                            <div style={{
                                width: "auto",
                                height: "auto",
                                margin: "0 auto",
                                overflow: "hidden",
                                ...getDynamicPadding()  // Dinamik padding uygula
                            }}>
                                <img
                                    src={soundurl}
                                    alt="Question Media"
                                    style={{
                                        width: "80%",
                                        height: "100%",
                                        maxHeight: "250px",
                                        objectFit: "contain", // Resmi kutuya sığdırırken oranlarını korur
                                        borderRadius: "10px", // Opsiyonel, görseli daha hoş göstermek için
                                    }}
                                />

                            </div>

                        </div>
                    </div>

                ) : (
                    <div></div>
                )}
                {obj['type'] === "sound" ? (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "100%",
                        maxWidth: "500px",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "500px"
                        }}>
                            <ReactAudioPlayer
                                src={url}
                                autoPlay={false}
                                controls={true}
                                controlsList="nodownload "

                            />
                        </div>

                    </div>

                ) : (
                    <div></div>
                )}
                {obj['type'] === "video" ? (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "100%",
                        maxWidth: "500px",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "500px",
                            minHeight: "300px"

                        }}>
                            <ReactPlayer
                                className='react-player'
                                width="100%"
                                height="300px"
                                url={url}
                                controls={true}
                            />
                        </div>

                    </div>

                ) : (
                    <div></div>
                )}
                {obj['type'] === "image" ? (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "auto",
                        maxWidth: "auto",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "auto",
                            height: "auto",
                            margin: "0 auto",
                            overflow: "hidden",
                            ...getDynamicPadding()  // Dinamik padding uygula
                        }}>
                            <img
                                src={url}
                                alt="Question Media"
                                style={{
                                    width: "80%",
                                    height: "100%",
                                    maxHeight: "250px",
                                    objectFit: "contain", // Resmi kutuya sığdırırken oranlarını korur
                                    borderRadius: "10px", // Opsiyonel, görseli daha hoş göstermek için
                                }}
                            />

                        </div>

                    </div>

                ) : (
                    <div></div>
                )}

                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "SteelBlue" }}>
                    {questionTitle}
                </b>
                <br />
                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "SteelBlue" }}>
                    {questionText}
                </b>
                <br />
            </div>

            <div className="d-flex justify-content-center" style={{ fontSize: 40 }}>
                <form onSubmit={handleSubmit}>
                    <div style={{ fontSize: "18px", lineHeight: "2" }}>
                        {parts.map((part, index) => (
                            <React.Fragment key={index}>
                                <span style={{ fontSize: "22px" }}>{part}</span>

                                {index < parts.length - 1 && sentenceAnswers[index] && (
                                    <select
                                        name={`blank_${index}`}
                                        className="dynamic-select"
                                        data-blank-index={index}
                                        required
                                    >
                                        <option value="" disabled hidden>
                                            Seçim yapınız
                                        </option>

                                        {sentenceAnswers[index].service.map((opt, i) => (
                                            <option key={i} value={i + 1}>
                                                {opt}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </React.Fragment>
                        ))}

                    </div>
                    {/* <iframe
                        src={link}
                        title="Question Link"
                          style={{
    width: "1000px",
    height: "390px", // ihtiyaca göre artır (600-800 iyi olur)
    border: "none"
  }}
                    /> */}
                    {/* Link.js Return içindeki ilgili bölüm */}
                    <div ref={containerRef} style={{ position: "relative", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: isFullscreen ? "#fff" : "transparent" }}>

                        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                            <button
                                type="button"
                                onClick={toggleFullscreen}
                                style={{
                                    border: "none",
                                    borderRadius: "5px",
                                    padding: "10px",
                                    background: "#3b5bdb",
                                    color: "white",
                                    cursor: "pointer",
                                    fontSize: "20px"
                                }}
                            >
                                {isFullscreen ? "Tam Ekrandan Çık" : "Etkinliği Tam Ekran Aç"}
                            </button>
                        </div>

                        {/* SADECE TAM EKRANDA GÖRÜNEN ZOOM BUTONLARI */}
                        {isFullscreen && (
                            <div style={{
                                position: "absolute",
                                top: "60px", // Tam ekrandan çık butonunun altına hizalanması için
                                right: "20px",
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                backgroundColor: "#ffffff",
                                padding: "6px 12px",
                                borderRadius: "20px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                border: "1px solid #e2e8f0"
                            }}>
                                <button
                                    type="button" onClick={handleZoomOut}
                                    style={{ cursor: "pointer", width: "30px", height: "30px", borderRadius: "50%", border: "none", background: "#f1f5f9", fontWeight: "bold", fontSize: "18px" }}
                                >-</button>
                                <span style={{ fontSize: "14px", fontWeight: "bold", minWidth: "45px", textAlign: "center" }}>
                                    %{Math.round(zoomLevel * 100)}
                                </span>
                                <button
                                    type="button" onClick={handleZoomIn}
                                    style={{ cursor: "pointer", width: "30px", height: "30px", borderRadius: "50%", border: "none", background: "#f1f5f9", fontWeight: "bold", fontSize: "18px" }}
                                >+</button>
                            </div>
                        )}

                        {/* IFRAME KISMI (Zoom Özelliği Eklendi) */}
                        <div style={{
                            width: isFullscreen ? "100%" : "700px",
                            height: isFullscreen ? "100vh" : "50vh",
                            overflow: isFullscreen ? "auto" : "hidden", // Tam ekranda büyüyünce kaydırma çubuğu çıkması için
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "flex-start"
                        }}>
                            <iframe
                                src={link}
                                title="Question Link"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "none",
                                    borderRadius: isFullscreen ? "0px" : "10px",
                                    transform: isFullscreen ? `scale(${zoomLevel})` : "scale(1)",
                                    transformOrigin: "top center",
                                    transition: "transform 0.2s ease-in-out"
                                }}
                            />
                        </div>
                    </div>
                    {props.answered ? (
                        <span> </span>
                    ) : (
                        <div className='d-flex justify-content-center' style={{ marginTop: "5px" }}>
                            <button type="submit" className="save-btn">BİR SONRAKİ OYUNA GEÇ</button>
                        </div>
                    )}
                </form>




            </div>

        </div>
    );
};

export default Link;
